











import Vue from 'vue'
import mixin from '@/mixins/msg-text-form-mixin'
export default Vue.extend({
    mixins: [mixin],
    props: {
        maxLength: {
            type: Number,
            default: null
        },
        rows: {
            type: Number,
            default: 3
        },
        validation: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            required: true
        }
    },
    // Enables vee-validate to work on text previously placed inside of a form without causing an error to be thrown
    // or loss of new text added to field
    beforeDestroy() {
        this.$validator.pause()
    }
})
